import React, { Component } from "react";
import classnames from "classnames";

import { Severity } from "@formant/core/model/Severity";
import { Icon, severityIcons } from "@formant/ui/component/common/Icon";

import * as styles from "./SeverityIcon.scss";

export interface ISeverityIconProps {
    severity: Severity;
    className?: string;
}

export class SeverityIcon extends Component<ISeverityIconProps> {
    public render() {
        const { severity } = this.props;

        const className = classnames(
            styles["severity-icon"],
            severity === "critical" && styles.critical,
            this.props.className,
        );

        const iconName = severityIcons[severity];
        if (!iconName) {
            return false;
        }

        return <Icon name={iconName} className={className} />;
    }
}
